module.exports = __webpack_public_path__ + "img/icon_sb_hand_truck_48x48.a08d43a.svg";